import { Pipe, PipeTransform } from '@angular/core';

/**
 * Strips all HTML tags from the input string,
 * returning plain text safe for use with CSS truncation.
 *
 * @example
 * {{ description | stripHtml }}
 */
@Pipe({ name: 'stripHtml', standalone: true })
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    const stripped = value.replace(/(<([^>]+)>)/gi, '');
    const lines = stripped.split(/\r?\n/).map(l => l.trim()).filter(l => l.length > 0);
    const text = (lines[1] ?? lines[0] ?? '').trim();
    return lines.length > 1 ? `${text}...` : text;
  }
}
/**
 * Strips any html characters
 * from the `target`, abbreviates the resulting string
 * to the max length, and appends an ellipsis character
 * to the result.
 *
 * @example
 * {{ title | ellipsis:200 }}
 */
@Pipe({ name: 'ellipsis', standalone: true })
export class EllipsisPipe implements PipeTransform {
  transform(target: string, maxLength: number = 125) {
    const htmlStripped = target.replace(/(<([^>]+)>)/gi, '');

    if (htmlStripped.length >= maxLength) {
      return `${htmlStripped.slice(0, maxLength)}...`;
    }
    return htmlStripped;
  }
}
